// extracted by mini-css-extract-plugin
export default {"wrapper":"M_ProgressBarPlant_wrapper__ihUnU","tree_icon_wrapper":"M_ProgressBarPlant_tree_icon_wrapper__6fk+g"};